import '@fontsource/neuton'
import '@fontsource/inter'
import '@fontsource/source-code-pro'
import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Global } from '@emotion/react'
import 'rsuite/dist/rsuite.min.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { DocumentStyles } from './styles/Document.styles'
import { initDebugColors } from './utils/debugColors'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const rootElement = document.getElementById('root')

if (rootElement) {
  rootElement.className = 'top'
}

// Initialize debug colors if enabled
initDebugColors()

// Telemetry stays off in local vite dev; CRA has no import.meta.env so use NODE_ENV.
if (process.env.NODE_ENV === 'production') {
  import('./lib/telemetry')
    .then((m) => m.initTelemetry())
    .catch(() => {})
}

const version = process.env.REACT_APP_VERSION


console.log(
  `%c🚀 Version: ${version?.toUpperCase()}`,
  'color: white; background-color: #e85f0f; padding: 2px 6px; border-radius: 3px;'
);

if (process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'staging') {
  console.log = () => {};
}

root.render(
  <StrictMode>
    <Global styles={DocumentStyles} />
    <App />
  </StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals.console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
